import { AuthCredential, linkWithCredential, unlink } from "firebase/auth";

import { Dispatch } from "common/types";

import { getFirebaseAuth } from "services/firebase/auth";
import { ProviderSSO } from "services/firebase/auth/types";

import { signInWithEmailAndPassword } from "features/user/actions/auth/signInWithEmailAndPassword";

import proceedUserSignIn from "./proceedUserSignIn";

type AttemptFirstMISLoginArgs = {
  region: string;
  providerName: ProviderSSO;
  onSignInSuccess?: () => void;
  credential: AuthCredential;
  email: string;
  onPasswordConfirmation: (info: {
    credential: AuthCredential;
    email: string;
  }) => void;
};

const MIS_PASSWORD = "seneca2020";

export default function attemptFirstMISLogin({
  region,
  onSignInSuccess,
  credential,
  email,
  onPasswordConfirmation
}: AttemptFirstMISLoginArgs) {
  return async function (dispatch: Dispatch) {
    try {
      await dispatch(signInWithEmailAndPassword(email, MIS_PASSWORD));

      const user = getFirebaseAuth().currentUser;
      await linkWithCredential(getFirebaseAuth().currentUser!, credential);
      await unlink(user!, "password");

      await dispatch(
        proceedUserSignIn({
          onSignInSuccess,
          region,
          userId: user!.uid
        })
      );
    } catch (err: any) {
      onPasswordConfirmation({
        credential,
        email
      });
    }
  };
}
